import { combineReducers } from 'redux'

import pageNumber from './pageNumber'
import pageSize from './pageSize'

export default combineReducers({
  pageNumber,
  pageSize,
})
